var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigatePrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29248 10.8725C6.68248 10.4825 6.68248 9.85248 6.29248 9.46248L2.41248 5.58248L6.29248 1.7025C6.68248 1.3125 6.68248 0.6825 6.29248 0.2925C5.90248 -0.0975 5.27248 -0.0975 4.88248 0.2925L0.2925 4.88248C-0.0975 5.27248 -0.0975 5.90248 0.2925 6.29248L4.88248 10.8825C5.26248 11.2625 5.90248 11.2625 6.29248 10.8725Z",
    fill: "#707683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigatePrevious);
export default __webpack_public_path__ + "static/media/navigate-previous.b2041bb5508c48d8b8e1bedea119eb74.svg";
export { ForwardRef as ReactComponent };